import { render, staticRenderFns } from "./UpdateCardModal.vue?vue&type=template&id=81becbc0"
import script from "./UpdateCardModal.vue?vue&type=script&lang=js"
export * from "./UpdateCardModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateCardModal.vue?vue&type=style&index=0&id=81becbc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports